export { default } from './StarHalf'
